export function getNodeTagNames(nodes?: Array<any> | null) {
  if (!nodes) {
    return [];
  }

  return nodes
    .filter((node) => node.nodeType === 'tags')
    .reduce(
      (acc, tag) => [
        ...acc,
        ...tag.payload.tag_ids.filter((t) => !acc.includes(t)),
      ],
      [],
    );
}
